import api from '@/apis'
import Vuetify from '@/plugins/vuetify'

export default {
  state: {
    submit_btn_disable: false,
    visibility: false,
    upload_success_session: 0,
    upload_success_language: '',
    file_language: ''
  },
  mutations: {
    INIT_UPLOAD_FILE_SCANNING_DIALOG(state, payload) {
      state.visibility = true
      state.file_language = payload?.language ?? ''
    },
    RESET_UPLOAD_FILE_SCANNING_DIALOG(state) {
      state.visibility = false
      state.file_language = ''
    },
    SET_UPLOAD_FILE_SCANNING_DIALOG_SUBMIT_BTN_DISABLE(state, payload) {
      state.submit_btn_disable = payload
    },
    BUMP_UPLOAD_FILE_SCANNING_DIALOG_SUCCESS_SESSION(state, payload) {
      state.upload_success_language = payload?.language ?? ''
      state.upload_success_session++
    }
  },
  actions: {
    async uploadFileForScanning({ commit }, payload) {
      try {
        commit('SET_SNACKBAR', { status: true, color: 'loading', text: Vuetify.locale.t('$vuetify.__SnackBar.uploading', ''), loading: true })
        commit('SET_UPLOAD_FILE_SCANNING_DIALOG_SUBMIT_BTN_DISABLE', true)

        const response = await api.addMrcDoc(payload)
        if (response.data.success) {
          commit('SET_SNACKBAR', {
            status: true,
            color: 'success',
            text: Vuetify.locale.t('$vuetify.__SnackBar.upload', Vuetify.locale.t('$vuetify.__General.file')),
            icon: 'check',
            timeout: '2000'
          })
          commit('RESET_UPLOAD_FILE_SCANNING_DIALOG')
          commit('BUMP_UPLOAD_FILE_SCANNING_DIALOG_SUCCESS_SESSION', { language: payload.params.get('language') })
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      } finally {
        commit('SET_UPLOAD_FILE_SCANNING_DIALOG_SUBMIT_BTN_DISABLE', false)
      }
    }
  }
}
